import { useDispatch } from 'react-redux';

import RefreshIcon from '@mui/icons-material/Refresh';
import { Grid, Box, Typography, Button } from '@mui/material';
import { useTranslation } from 'next-i18next';
import courseActions from 'src/redux/course/actions';

import Style from './style';

import FontAwesomeIcon from '@components/atoms/fontAwesomeIcon';

const { clear_course_filter } = courseActions;

type Props = {
  title: string;
};

const CourseNotFoundWithFilterMessage = ({ title }: Props) => {
  const { t } = useTranslation('common');
  const dispatch = useDispatch();

  const resetFilterClick = () => {
    dispatch(clear_course_filter());
  };

  return (
    <Style container sx={{ mt: 3 }}>
      <Grid item xs>
        <Box sx={{ display: 'flex', justifyContent: 'center', m: 2 }}>
          <FontAwesomeIcon icon="fa-light fa-telescope" />
        </Box>
        <Typography className="title" variant="h4" component="div">
          <b>{title}</b>
        </Typography>
        <Typography className="description" variant="subtitle1" component="div">
          {t('search_course.filter_course_not_found.desc')}
        </Typography>
        <Box sx={{ display: 'flex', justifyContent: 'center', m: 2 }}>
          <Button
            variant="contained"
            className="reset-filter-button"
            startIcon={<RefreshIcon />}
            onClick={resetFilterClick}
          >
            {t('all_course.filter.reset_filter')}
          </Button>
        </Box>
      </Grid>
    </Style>
  );
};

export default CourseNotFoundWithFilterMessage;
